import React from "react";

import { CheckboxV2Root, type CheckboxV2RootProps } from "../../ui/CheckboxV2Primitive";
import { cn } from "@/libs/cn";

export interface CheckboxV2Props extends CheckboxV2RootProps {
  label?: string;
  labelClassName?: string;
}

const CheckboxV2 = React.forwardRef<React.ElementRef<typeof CheckboxV2Root>, CheckboxV2Props>(
  ({ label, className, labelClassName, variant, shape, size, ...props }, ref) => {
    const autoId = React.useId();
    const id = props.id ?? autoId;

    if (label) {
      return (
        <div className="flex items-center gap-3">
          <CheckboxV2Root ref={ref} id={id} className={className} variant={variant} shape={shape} size={size} {...props} />
          <label
            htmlFor={id}
            className={cn(
              "text-sm font-medium leading-none text-ui-text select-none cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
              labelClassName,
            )}
          >
            {label}
          </label>
        </div>
      );
    }

    return <CheckboxV2Root ref={ref} id={id} className={className} size={size} {...props} />;
  },
);

CheckboxV2.displayName = "CheckboxV2";

export default CheckboxV2;
